import { createContext } from "react";

import { Patient } from "@medplum/fhirtypes";

interface PatientContextOptions {
  patient: Patient | undefined;
  setPatient: (patient: Patient) => void;
}

export const PatientContext = createContext<PatientContextOptions>({
  patient: undefined,
  setPatient: () => null,
});
